import { useExtraConfigContext } from '@gov-nx/core/app/extra-config/ExtraConfigProvider';

export const useEnvironment = () => {
	const {
		extraConfig: { environment },
	} = useExtraConfigContext();

	return {
		isLocalhost: environment === 'lcl',
	};
};
